import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';

const ResetRxTemplateModal: React.FC<{
    onCancel: () => void;
    onReset: () => void;
}> = ({ onCancel, onReset }) => {
    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div className="absolute inset-0 bg-darwin-neutral-1000 bg-opacity-50 z-50"></div>
                <div
                    className="modal-content space-y-16"
                    style={{
                        position: 'absolute',
                        width: '400px',
                        background: 'transparent',
                    }}
                >
                    <div className="p-24 bg-white flex flex-col rounded-12 items-center space-y-12">
                        <div className="flex space-x-16">
                            <span className="mt-4">
                                <svg
                                    className="w-16 h-16 fill-darwin-status-warning-500"
                                    viewBox="0 0 18 14"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M9 0C9.4375 0 9.84375 0.25 10.0625 0.625L16.8125 12.125C17.0312 12.5312 17.0312 13 16.8125 13.375C16.5938 13.7812 16.1875 14 15.75 14H2.25C1.78125 14 1.375 13.7812 1.15625 13.375C0.9375 13 0.9375 12.5312 1.15625 12.125L7.90625 0.625C8.125 0.25 8.53125 0 9 0ZM9 4C8.5625 4 8.25 4.34375 8.25 4.75V8.25C8.25 8.6875 8.5625 9 9 9C9.40625 9 9.75 8.6875 9.75 8.25V4.75C9.75 4.34375 9.40625 4 9 4ZM10 11C10 10.4688 9.53125 10 9 10C8.4375 10 8 10.4688 8 11C8 11.5625 8.4375 12 9 12C9.53125 12 10 11.5625 10 11Z" />
                                </svg>
                            </span>
                            <span className="font-700 text-18 text-center">
                                Are you sure you want to reset to your old template?
                            </span>
                        </div>
                        <span className="text-14 px-16 text-darwin-neutral-800 text-center">
                            All your current changes will be lost and cannot be recovered later.
                        </span>

                        <div className="flex items-center space-x-16">
                            <button
                                onClick={onCancel}
                                className="flex px-16 py-6 secondary-btn btn--small cursor-pointer items-center"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={onReset}
                                className="flex px-16 py-6 bg-white border rounded-4 text-darwin-status-warning-500 btn--small cursor-pointer items-center"
                            >
                                Yes, reset
                            </button>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default ResetRxTemplateModal;
